module.exports = __webpack_public_path__ + "img/scene3.51b75781.png";